import {
  ASSOCIATION_SOURCE_OF_FUNDS_OPTIONS,
  ASSOCIATION_SOURCE_OF_FUNDS_OPTIONS_V2,
  BUSINESS_RELATIONSHIPS_OPTIONS,
} from '../../constants/business-activity';

interface BusinessRelationshipsLabelOptions {
  useV2Options: boolean;
  isAssociation: boolean;
  isFoundation: boolean;
}

interface SourceOfFundOption {
  value: string;
  i18nKey: string;
}

export function getBusinessRelationshipsOptions({
  useV2Options,
  isAssociation,
  isFoundation,
}: BusinessRelationshipsLabelOptions): readonly SourceOfFundOption[] {
  if (useV2Options) {
    return ASSOCIATION_SOURCE_OF_FUNDS_OPTIONS_V2;
  }

  const sourceOfFundsOptions =
    isAssociation || isFoundation
      ? ASSOCIATION_SOURCE_OF_FUNDS_OPTIONS
      : BUSINESS_RELATIONSHIPS_OPTIONS;

  return sourceOfFundsOptions.map(value => ({
    value,
    i18nKey: value.replace(/_/g, '-'),
  }));
}
